import React from 'react';
// import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { STRING_LIST } from '../common/constant';


const Avatar = React.memo((props) => {
    const anArray = props?.name?.split(' ') ? props.name?.split(' ').filter(item => item) : [];
    const alphabet = [];
    let color = '#000000';
    for (let i = 0; i < 26; i++) {
        alphabet.push((i + 10).toString(36));
        if (anArray[0]?.charAt(0).toLowerCase() === alphabet[i]) {
            color = STRING_LIST.COLOR[i];
        }
    }

    const imageError = (e) => {
        e.target.src = 'https://files.superworks.com/custom/images/user-avatar.png'
    }

    /**
     * Two words -> one initial from each; one word -> its first two characters; no usable name ->
     * nothing. The last case used to build the literal string "undefinedundefined", which rendered
     * as visible text inside the avatar.
     */
    const initials = anArray.length > 1
        ? `${anArray[0].charAt(0)}${anArray[1].charAt(0)}`
        : (anArray[0] ? anArray[0].slice(0, 2) : '');

    return (
        <React.Fragment>
            <div className={`u_avatar ${props.className || ''}`}>
                {/*
                  * Any falsy image means "no picture" - render initials. A plain `!== undefined`
                  * check let `null` through, which built a src ending in "null", failed to load and
                  * left a broken image box where the initials should be.
                  */}
                {props.image ?
                    <img draggable='false' src={props.thumbor + props.s3Url + props.image} onError={(e) => imageError(e)}
                        alt="" className={`u_avatar-image ${props.className || ''}`}
                        style={{ width: `${props.width}px`, height: `${props.width}px` }} />
                    :
                    <div className={`u_avatar-content ${props.className || ''}`}
                        style={{ backgroundColor: `${color}`, width: `${props.width}px`, height: `${props.width}px` }}>
                        <span className="u_m-auto" style={{
                            fontSize: `${(props.width / 3) / 10}rem`,
                            lineHeight: `${(props.width / 3) / 10}rem`
                        }}>{initials}</span>
                    </div>

                }
            </div>
        </React.Fragment>
    );
});

Avatar.propTypes = {
    image: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    thumbor: PropTypes.string,
    s3Url: PropTypes.string,

};
Avatar.defaultProps = {
    width: 40,
    thumbor: ''
};

export default Avatar;
